import { useNavigate } from 'react-router-dom';
import styles from './button.module.scss';
import arrow from '../../Assets/Images/Icons/Other/arrow.png';

const Button = (props) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (props.disabled || props.loading) return;

        if (props.link) {
            // External link
            if (props.link.startsWith('http')) {
                window.open(props.link, '_blank');
            } else {
                // Internal route
                navigate(props.link);
            }
        } else if (props.onClick) {
            props.onClick();
        }
    };

    return (
        <button
            className={`${styles.button} ${props.selected ? styles.selected : ''}`}
            style={props.customStyle}
            disabled={props.loading || props.disabled}
            onClick={handleClick}
        >
            {props.submitted && !props.loading ? (
                /* Show response only when done loading */
                <div className={styles.responseMessage}>{props.responseMessage}</div>
            ) : (
                <div className={styles.buttonContent}>
                    {props.buttonText}

                    {/* Icon / loader section */}
                    {props.loading ? (
                        <div className={styles.buttonLoader} />
                    ) : (
                        props.displayIcon && (
                            <img src={arrow} alt='icon' className={styles.buttonImage} />
                        )
                    )}
                </div>
            )}
        </button>
    );
};

export default Button;
